export class CulturaProduto {
    Id: number;
    ProdutoId: number;
    CulturaId: number;
    IntervaloSegurancaColheita:number = 0;
    PrazoReentrada:number = 0;
}
